import styled from '../../styled';
import { COLORS } from '../../themes/color';

/**
 * Small uppercase label above section headlines.
 */
export const Kicker = styled('div')<{ onDark?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(p) => (p.onDark ? COLORS.PRIMARY_LIGHT : COLORS.PRIMARY)};
  margin-bottom: 16px;

  @media (max-width: 600px) {
    font-size: 11px;
    letter-spacing: 0.05em;
    margin-bottom: 12px;
  }
`;
